import * as React from "react";

import { cn } from "@/lib/utils";
import { useController } from "react-hook-form";
import { Checkbox } from "@/components/ui/checkbox";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";

interface DataTableCellCheckboxProps
  extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> {
  className?: string;
  name: string;
}

const DataTableCellCheckbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  DataTableCellCheckboxProps
>((props, ref) => {
  // TODO: add an error message as an icon with tooltip AR-451
  const controller = useController({ name: props.name });
  const defaultStyle = "rounded-sm focus-visible:ring-offset-0";
  const errorStyle = "border-red-500 text-red-800 focus-visible:ring-red-500";

  return (
    <div className="flex items-center justify-center h-full py-[2px] px-2">
      <Checkbox
        ref={ref}
        {...props}
        checked={controller.field.value}
        onCheckedChange={controller.field.onChange}
        className={cn(
          defaultStyle,
          {
            [errorStyle]: controller.fieldState.error,
          },
          props.className,
        )}
      />
    </div>
  );
});

DataTableCellCheckbox.displayName = "DataTableCellCheckbox";

export default DataTableCellCheckbox;
